<fui-edit-fascia [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <ng-content select="fui-validator"></ng-content>
    <fui-fixtures>
        <fui-fixture>
            <fui-input-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                             [title]="label" [i18nParams]="labelI18NParams" [valued]="valued"></fui-input-label>
        </fui-fixture>
    </fui-fixtures>
    <fui-fixtures>
        <fui-fixture *ngIf="icon">
            <ng-content select="fui-icon"></ng-content>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-textarea-dom>
                <textarea (blur)="onBlur($event)" [disabled]="disabled" #input (focus)="onFocus($event)" [(ngModel)]="value"
                          [placeholder]="placeholder | translate" [tabindex]="tabindex"></textarea>
            </fui-textarea-dom>
        </fui-spanning-fixture>
        <fui-fixture *ngIf="validateable" class="validationFixture">
             <fui-validations [control]="control" [focussed]="focussed"
                              [forceRequired]="forceRequired"></fui-validations>
        </fui-fixture>
    </fui-fixtures>
</fui-edit-fascia>
